import { render, staticRenderFns } from "./SingleSelect.vue?vue&type=template&id=44b3afba&scoped=true"
import script from "./SingleSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleSelect.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SingleSelect.vue?vue&type=style&index=0&id=44b3afba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b3afba",
  null
  
)

export default component.exports